export interface RawSavedWord {
  word: string;
  theme?: string;
  createdAt: number;
  lastPractice?: number;
  progress: number;

  translation?: string;
  exampleSentence?: string;
  imageUrl?: string;
  synonyms?: string[];

  successCount?: number;
  failCount?: number;

  type?: 'single_word' | 'compound_word' | 'phrasal_verb' | 'idiom' | 'expression';
  literalMeaning?: string;
  exampleTranslation?: string;
  definitionTranslation?: string;
}

export interface SavedWord {
  id: string;
  userId: string;

  word: string;
  theme?: string;
  createdAt: number;
  lastPractice?: number;
  progress: number;

  translation?: string;
  exampleSentence?: string;
  imageUrl?: string;
  synonyms: string[];

  successCount: number;
  failCount: number;
  
  isUnsaved?: boolean;

  type?: 'single_word' | 'compound_word' | 'phrasal_verb' | 'idiom' | 'expression';
  literalMeaning?: string;
  exampleTranslation?: string;
  definitionTranslation?: string;
}

export function mapRawSavedWord(userId: string, id: string, raw: RawSavedWord): SavedWord {
  return {
    id,
    userId,
    word: raw.word,
    theme: raw.theme,
    createdAt: raw.createdAt,
    lastPractice: raw.lastPractice,
    progress: raw.progress ?? 0,
    translation: raw.translation,
    exampleSentence: raw.exampleSentence,
    imageUrl: raw.imageUrl,
    synonyms: raw.synonyms ?? [],
    successCount: raw.successCount ?? 0,
    failCount: raw.failCount ?? 0,
    type: raw.type,
    literalMeaning: raw.literalMeaning,
    exampleTranslation: raw.exampleTranslation,
    definitionTranslation: raw.definitionTranslation,
  };
}

export interface UserStats {
  userId: string;
  totalPoints: number;
  dailyPoints: { [isoDate: string]: number };
  streakCount: number;
  lastActiveDate?: string;
  completedSessions?: number;
  wordDayStreak?: number;
  lastWordDayDate?: string;
}

export enum ActivityType {
  Review = 'review',
  SentenceFormation = 'sentence_formation',
  ListenToWrite = 'listen_to_write',
  Translation = 'translation',
  ImageLinking = 'image_linking',
  SpeakWord = 'speak_word',
  SpeakPhrase = 'speak_phrase',
  Synonyms = 'synonyms',
  ListenAndArrange = 'listen_and_arrange',
  FillInTheBlanks = 'fill_in_the_blanks',
  Matching = 'matching',
}

export interface TrainingSessionItem {
  word: SavedWord;
  activities: ActivityType[];
}
